<script setup lang="ts">
import type { BibleBook } from '~/types/bible'
import { useBibleTranslations } from '~/composables/useBibleData'

const { book } = defineProps<{
  book: BibleBook
}>()

const { data: translations } = await useBibleTranslations()

const translation = computed(() => {
  return translations.value?.find((t) => t.code === book.translation)?.name
})
</script>

<template>
  <TagLink v-if="translation" :href="`/bible/${book.translation}/testament/${book.testament}/`">
    {{ translation }}
  </TagLink>
</template>

<style scoped></style>
